import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';

/**
 * Toolbar toggle for the logged-in calendar: show / hide conventions
 * (stevner og treninger) as purple events on top of the calendar.
 *
 * Tilleggsmodul (C, shooting). The shared calendar renders it through the
 * components-other registry, so the Dyrejournal build never sees it and never
 * asks the backend for conventions. Visibility mirrors the "Shooting
 * convention" menu entry: the customer has the shootingTools module, or the
 * user is an admin.
 */
@observer
class ConventionCalendarToggle extends Component {
    static isAvailable(stores = {}) {
        const { appState = {}, userStore = {} } = stores;
        const { currentCustomer = {} } = appState;
        return !!(currentCustomer?.menuItems?.shootingTools || userStore.isAdmin);
    }

    onClick = e => {
        e.preventDefault();
        e.stopPropagation();
        const { calendarStore } = this.props.stores;
        const { onToggle = () => {} } = this.props;
        calendarStore.toggleShowConventions();
        onToggle();
    }

    render() {
        if (!ConventionCalendarToggle.isAvailable(this.props.stores)) {
            return null;
        }
        const { calendarStore } = this.props.stores;
        const { showConventions } = calendarStore;
        // Bootstrap has no purple button variant; --bs-purple matches the
        // event colour the backend stamps on convention events.
        const style = showConventions
            ? 'background-color: var(--bs-purple); border-color: var(--bs-purple); color: #fff;'
            : 'background-color: transparent; border-color: var(--bs-purple); color: var(--bs-purple);';
        return (
            <Localizer>
                <button
                    type='button'
                    class='btn btn-sm rounded-pill'
                    style={style}
                    data-toggle='conventions'
                    aria-pressed={!!showConventions}
                    onClick={this.onClick}
                    title={showConventions
                        ? <Text id='calendar.hide-conventions'>Hide conventions and trainings</Text>
                        : <Text id='calendar.show-conventions'>Show conventions and trainings</Text>}
                >
                    <i class='fa-duotone fa-bullseye-pointer' />
                </button>
            </Localizer>
        );
    }
}

export default ConventionCalendarToggle;
